import EpisodeCard from '@components/episode/EpisodeCard';
import { useEpisodeCardController } from './useEpisodeCardController';

export default function EpisodeCardController({ episode, onPlayClick }) {
  const viewModel = useEpisodeCardController({ episode, onPlayClick });
  return <EpisodeCard {...viewModel} />;
}
